import {stringify} from 'qs'
import request from 'crm/utils/request'
import api from 'crm/common/api/home'

export async function todayCustomerStat() {
    return request(api.todayCustomerStat.url)
}

export async function todayChannelRank() {
    return request(api.todayChannelRank.url)
}

export async function customerStat(params) {
    return request(`${api.customerStat.url}?${stringify(params)}`)
}

export async function customerChannels() {
    return request(api.customerChannels.url)
}

export async function lostCustomers(payload = {}) {
    return request(api.lostCustomers.url, {
        method: api.lostCustomers.type,
        body: payload.body,
    })
}
